<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{aLang.c_list}} {{aLang.tg_title}}
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="3">
                    <el-form-item :label="aLang.tg_fullname" prop>
                      <el-input
                        v-model="mData.tableRules.dataSearch.value['ho_ten.ho_ten']"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item :label="aLang.tg_email" prop>
                      <el-input v-model="mData.tableRules.dataSearch.value['email']" clearable></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item :label="aLang.tg_phone" prop="dien_thoai">
                      <el-input
                        type="text"
                        v-model="mData.tableRules.dataSearch.value.dien_thoai"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item :label="aLang.tg_card_number" prop>
                      <el-input
                        type="text"
                        v-model="mData.tableRules.dataSearch.value['the_hdv.so_the']"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                  >{{aLang.c_search}}</el-button>
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col md="8" class="p-0">
            <b-col md="4"></b-col>
          </b-col>
          <b-col md="4">
            <div class="text-right mb-2">
              <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                plain
              >{{aLang.c_showHideSearch}}</el-button>
              <!-- <el-button @click="fn_handle('create')" type="info" plain>{{aLang.c_create}}</el-button> -->
            </div>
          </b-col>
        </b-row>

        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1]}"
        >
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>
          <el-table-column
            prop="ho_ten"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.tg_fullname"
            min-width="200"
          >
            <template slot-scope="scope">
              <el-link
                class="cell-child"
                target="_blank"
                @click="fn_handle('detail',scope.$index, scope.row)"
                :underline="false"
              >{{scope.row.ho_ten.ho_ten}}</el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="the_hdv.so_the"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.tg_card_number"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="gioi_tinh"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.tg_gender"
            width="100"
            align="center"
          ></el-table-column>

          <el-table-column
            prop="ngay_sinh.nam"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.tg_bod"
            width="120"
            align="center"
          >
            <template slot-scope="scope">{{scope.row.ngay_sinh.ngay_sinh}}</template>
          </el-table-column>
          <el-table-column
            prop="email"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.tg_email"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="dien_thoai"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.tg_phone"
            width="120"
            align="right"
          ></el-table-column>

          <el-table-column prop="so_sao" :label="aLang.tg_evaluate" width="100" align="center">
            <template slot-scope="scope">
              <el-link
                class="cell-child"
                target="_blank"
                @click="fn_goDanhGia('detail',scope.$index, scope.row)"
                :underline="false"
              >{{scope.row.so_sao}}</el-link>
            </template>
          </el-table-column>

          <el-table-column :label="aLang.c_action" align="center" width="150px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_handle('detail',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button>
              <!-- <el-button
                size="mini"
                @click="fn_handle('update',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update"
              >
                <i class="icon-pencil icons"></i>
              </el-button>-->
              <!-- <el-button
                size="mini"
                @click="fn_handle('delete',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete"
              >
                <i class="icon-trash icons"></i>
              </el-button>-->
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div
              v-if="mData.tableRules.allowSelect"
            >{{aLang.c_select}}: {{mData.tableRules.recordSelected.length}}</div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import HuongDanVienModel from "./HuongDanVienModel";
import HuongDanVienApi from "../../../moduleApi/HuongDanVienApi";
import DanhGiaApi from "../../../moduleApi/DanhGiaApi";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "HuongDanVien", //requied
        tableRules: MethodService.copyObject(HuongDanVienModel.tableRules),
        dataDefault: {
          roles: DataService.roles,
          listCongTyLuHanh: [],
          listStar: []
        }
      }
    };
  },

  methods: {
    //get list table
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
        fields:
          "id,ho_ten,email,dien_thoai,gioi_tinh,ngay_sinh,giay_to,quoc_tich,dia_chi,avatar_id,the_hdv,ngoai_ngu,so_truong,thanh_tich,lich_su_hanh_nghe"
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters,
            showFormSearch: this.mData.tableRules.showFormSearch
          }
        });
      }

      let res = await HuongDanVienApi.list(dataFilter);
      //get Danh gia
      let huongDanVienIds = MethodService.findListItemDifferent(
        res.result,
        "id"
      );
      if (huongDanVienIds.length > 0) {
        let resDanhGia = await DanhGiaApi.getStar(huongDanVienIds);
        this.mData.dataDefault.listStar = resDanhGia.result;

        for (var itemData in res.result) {
          if (
            this.mData.dataDefault.listStar.find(
              item => item.id === res.result[itemData].id
            )
          ) {
            res.result[itemData].so_sao =
              Math.round(
                this.mData.dataDefault.listStar.find(
                  item => item.id === res.result[itemData].id
                ).star
              ) + "/5";
          } else {
            res.result[itemData].so_sao = null;
          }
        }
      }

      //end get Danh gia
      this.mData.tableRules.data = this.changeData(res.result);
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.fn_initTable();
      }
    },

    //xử lý dữ liệu đầu ra
    changeData(data) {
      $.each(data, (index, item) => {
        if (item.gioi_tinh != undefined) {
          let gt = DataService.gioiTinh.find(element => {
            return element.id == item.gioi_tinh;
          });
          if (gt) {
            item.gioi_tinh = gt.text;
          }
        }
        // if (item.ngay_sinh != undefined) {
        //   item.ngay_sinh.ngay_sinh = new Date(
        //     item.ngay_sinh.nam,
        //     item.ngay_sinh.thang - 1,
        //     item.ngay_sinh.ngay
        //   ).toUTCString();
        // }
        if (!item.ngay_sinh || (item.ngay_sinh && (!item.ngay_sinh.ngay || !item.ngay_sinh.thang || !item.ngay_sinh.nam))) {
          item['ngay_sinh'] = {ngay_sinh: null};
        } else {
          item.ngay_sinh.ngay_sinh =
            ("0" + item.ngay_sinh.ngay).slice(-2) +
            "/" +
            ("0" + item.ngay_sinh.thang).slice(-2) +
            "/" +
            item.ngay_sinh.nam;
        }
      });
      return data;
    },

    fn_goDanhGia(type, scope, row) {
      if (type == "detail") {
        this.$router.push({
          name: "Admin-DanhGia-list",
          query: {
            filters: "doi_tuong_danh_gia_id:in:" + row.id
            // backModule : "huong_dan_vien"
          }
        });
      }
    },

    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create"
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id }
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
      if (type == "disable") {
        this.$confirm(LanguageService.lang.user_disableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_disable(row.id, true);
          })
          .catch(() => {});
      }
      if (type == "openDisable") {
        this.$confirm(LanguageService.lang.user_openDisableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_disable(row.id, false);
          })
          .catch(() => {});
      }
    },

    //delete
    async fn_delete(id) {
      await HuongDanVienApi.delete(id);
      this.fn_initTable();
    },

    //khóa tài khoản
    async fn_disable(id, disable) {
      await HuongDanVienApi.disable(id, disable);
      this.fn_initTable();
    },

    //event table

    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function(element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        if (column.prop == "ngay_sinh") {
          this.mData.tableRules.sort =
            "ngay_sinh.nam,ngay_sinh.thang,ngay_sinh.ngay";
        } else if (column.prop == "ho_ten") {
          this.mData.tableRules.sort = "ho_ten.ten";
        } else {
          this.mData.tableRules.sort = column.prop;
        }
      } else if (column.order == "descending") {
        if (column.prop == "ngay_sinh") {
          this.mData.tableRules.sort =
            "-ngay_sinh.nam,-ngay_sinh.thang,-ngay_sinh.ngay";
        } else if (column.prop == "ho_ten") {
          this.mData.tableRules.sort = "-ho_ten.ten";
        } else {
          this.mData.tableRules.sort = "-" + column.prop;
        }
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {

      this.$refs["myForm"].validate(async valid => {
        if (valid) {
        if(this.mData.tableRules.dataSearch.value['ho_ten.ho_ten']){
          this.mData.tableRules.dataSearch.value['ho_ten.ho_ten'] = this.mData.tableRules.dataSearch.value['ho_ten.ho_ten'].trim();
        }
        if(this.mData.tableRules.dataSearch.value['email']){
          this.mData.tableRules.dataSearch.value['email'] = this.mData.tableRules.dataSearch.value['email'].trim();
        }
        if(this.mData.tableRules.dataSearch.value.dien_thoai){
          this.mData.tableRules.dataSearch.value.dien_thoai= this.mData.tableRules.dataSearch.value.dien_thoai.trim();
        }
        if(this.mData.tableRules.dataSearch.value['the_hdv.so_the']){
          this.mData.tableRules.dataSearch.value['the_hdv.so_the'] = this.mData.tableRules.dataSearch.value['the_hdv.so_the'].trim();
        }
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterRoles(row, column, cellValue, index) {
      var roles = "";
      cellValue.forEach(item => {
        for (let i = 0; i < this.mData.dataDefault.roles.length; i++) {
          if (item == this.mData.dataDefault.roles[i].value) {
            item = this.mData.dataDefault.roles[i].label;
            roles += item + " ,";
          }
        }
      });
      roles = roles.slice(0, -1);
      return roles;
    },

    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    }
  },

  //run after render view
  created() {
    this.fn_hashUrl();
  },
  mounted() {
    this.fn_initTable();
  }
};
</script>
